import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-[#E5E5E5] bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-16">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-2">
              <span className="font-heading font-bold text-3xl tracking-tight text-[#111111]">ZONA</span>
              <span className="font-heading font-medium text-3xl tracking-tight text-[#777777]">SPORTS</span>
            </div>
            <p className="mt-5 max-w-sm text-[#333333] leading-relaxed">
              Education. Infrastructure. Development. Because making sports better means making
              the world better through sport.
            </p>
            <div className="mt-6 flex items-center gap-2 text-[#777777]">
              <MapPin size={18} />
              <span className="font-heading text-sm uppercase tracking-[0.18em]">Liverpool, United Kingdom</span>
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="font-heading text-xs uppercase tracking-[0.22em] text-[#777777]">Navigate</h4>
            <ul className="mt-5 space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About" },
                { to: "/services", label: "Services" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="font-heading text-sm uppercase tracking-[0.16em] text-[#111111] hover:text-[#777777] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-xs uppercase tracking-[0.22em] text-[#777777]">Work with us</h4>
            <p className="mt-5 text-[#333333] leading-relaxed text-sm">
              For partnerships, programmes and enquiries.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-5 inline-flex items-center gap-2 font-heading text-sm uppercase tracking-[0.16em] text-[#111111] border-b border-[#111111] pb-1 hover:gap-3 transition-all"
            >
              Get in touch <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-[#E5E5E5] pt-8 md:flex-row md:items-center md:justify-between">
          <p className="text-xs uppercase tracking-[0.16em] text-[#777777]">
            © {new Date().getFullYear()} ZONA Sports LTD — Registered in the United Kingdom
          </p>
          <p className="font-heading text-xs uppercase tracking-[0.22em] text-[#777777]">
            Find Your Zone
          </p>
        </div>
      </div>
    </footer>
  );
};
